import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { areResultsOwnedByUser } from 'selectors';

import { NavLink } from 'react-router-dom';

const TEXT = 'Shared Results';

class SharedResultsLink extends PureComponent {
  render() {
    const { currentResult, areResultsOwnedByUser } = this.props;
    if (currentResult && !areResultsOwnedByUser) {
      return (
        <NavLink
          exact
          className="Header-navigation-item"
          to={`/results/${currentResult}`}
        >
          {TEXT}
        </NavLink>
      );
    } else {
      return null;
    }
  }
}

function mapStateToProps(state) {
  return {
    areResultsOwnedByUser: areResultsOwnedByUser(state),
    currentResult: state.currentResult,
  };
}

export default connect(mapStateToProps)(SharedResultsLink);



// WEBPACK FOOTER //
// ./src/Components/Layout/SharedResultsLink.js